import React from "react";
import { Form } from "react-bootstrap";
import AsyncSelect from "react-select/async";
import * as Api from "../../General/api";
import * as Common from "../../General/common";
import Loader from "react-loader-spinner";
import AddEMRCredentail from "./addEditEMR";
import AddFacilityGroup from "./addFacilityGroup";
import PopupModal from '../modal/popupmodal';
import CheckPermission from "../../General/CheckPermission";
import RBAC, { ModulesName, UserActions } from "../../General/roleModuleActions";
import NewBrightreePhysician from '../physician/newbrightreephysician';
import { connect } from 'react-redux';
import { Animated } from "react-animated-css";

var emrModal, addEMR, facilityGroupModal = null;
class AddFacility extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            IsLoading: false,
            physicianList: [],
            physician: null,
            physiciansInputValue: '',
            selectOrgOptions: [],
            physicianList: [],
            selectOrgChainOptions: [],
            selectFacilityTypeOptions: [],
            addBtPhysicianModal: false,
            selectProductOptions: [],
            selectGroupPurchasingOptions: [],
            selectEhrvendorOption: [],
            selectWarehouseOption: [],
            selectClinicianOptions: [],
            manager: '',
            vicePresident: '',
            states: [],
            formValidated: false,
            isHeadquarters: false,
            emr: {
                id: null,
                name: '',
                description: '',
                loginId: '',
                password: '',
                isCredentailUpdate: true,
            },
            Facilty: {
                
                fkOrgId: null,
                fkChainId: null,
                facilityName: "",
                fkFacilityTypeId: null,
                npi: "",
                fkProductLineId: null,
                numberofBeds: null,
                fkGroupPurchasingOrg: null,
                websiteAddress: "",
                partBrecPerson: "",
                partBrecPersonPhone: "",
                centerSupplyPersonPhone: "",
                partBrecPersonEmail: "",
                centerSupplyPersonEmail: "",
                centralSupplyPerson: "",
                primaryBillingPerson: "",
                primaryBillingPersonPhone: "",
                primaryBillingPersonEmail:"",
                logoUrl: "",
                emrpassword: '',
                emrlogin: '',
                fkAssignedNurseId: null,
                fkEhrvendorId: null,
                vendorFacilityId: "",
                fkWarehouseId: null,
                physicianName: '',
                fkPhysicianId: null,
                medicarePartBbyGentell: false,
                outProgram: false,
                isEmr: false,
                isThisFacilityFollowingTheCycle: false,
                isEcp: false,
                singingForAllCmns: false,
                canAddAssessment: false,
                memo: "",
                fkClinicianId: null,
                isEmr: false,
                active: true,
                selectOutsSpecialistOptions: [],
                selectEnteralSpecialistOptions: [],
                isEmr: false,
                billTypeOuts: '',
                billTypeEnteral: '',
                billTypeOptions: [],
                address: {
                    // AddressId:null,
                    addressLine1: "",
                    addressLine2: "",
                    city: "",
                    stateId: null,
                    countryId: 1,
                    zip: "",
                    phone1: "",
                    email: "",
                    mobile1: "",
                    fax: "",
                },
                physicianViewModel: {
                    physicianId: 0,
                    title: "",
                    firstName: "",
                    middleName: "",
                    lastName: "",
                    suffix: "",
                    physicianNote: "",
                    npi: "",
                    stateMedicaidId: "",
                    licenseNo: "",
                    TaxonomyCode: "",
                    brightreeId: 0,
                    doctorGroupId: 0,

                    address: {
                        addressId: 0,
                        addressLine1: "",
                        addressLine2: "",
                        city: "",
                        sateId: 1,
                        countryId: 1,
                        zip: "",
                        phone1: "",
                        email: "",
                        mobile1: "",
                        fax: "",
                    },
                },
            },
        };
        this.emailError = false;
    }
    componentDidMount() {
        this.getAllFacilityGroup();
        this.getAllLookupsValues();
        this.getAllState();
        this.getAllActiveEMR();
        this.setState({ IsLoading: true });
        this.getBillTypeOptions();

    }
    getAllFacilityGroup = () => {
        Api.getRequest(Api.Uri_GetOrganization)
            .then((response) => {
                const data = response.data.result;
                let optionTemplate = data.map((v) => (
                    <option key={v.key} value={v.key}>
                        {v.value}
                    </option>
                ));
                this.setState({ selectOrgOptions: optionTemplate });
                this.setState({ selectOrgChainOptions: optionTemplate });
            })
    }
    getBillTypeOptions = () => {
        Api.getRequestById(Api.Uri_GetLookupValuesByFkId, 1026)
            .then((res) => {
                //console.log("Bill Type API Response:", res);
                if (res.data.statusCode === 200 && res.data.result) {
                    this.setState({ billTypeOptions: res.data.result });
                }
            })
            .catch(err => {
                Common.LogError(err, "AddFacility", "getBillTypeOptions");
            });
    };


    async getAllLookupsValues() {
        this.setState({ IsLoading: false });

        var facilityType = await Common.getLookupOptions(
            Common.LookupsFK.Fk_FacilityTypeID
        );
        this.setState({ selectFacilityTypeOptions: facilityType });

        var productLine = await Common.getLookupOptions(
            Common.LookupsFK.Fk_ProductLineID
        );
        this.setState({ selectProductOptions: productLine });

        var selectEhrvendorOption = await Common.getLookupOptions(
            Common.LookupsFK.Fk_EHRVendorID
        );
        this.setState({ selectEhrvendorOption: selectEhrvendorOption });

        var selectWarehouseOption = await Common.getLookupOptions(
            Common.LookupsFK.Fk_WarehouseID
        );
        this.setState({ selectWarehouseOption: selectWarehouseOption });

        var clinicain = await Api.getRequestById(Api.Uri_GetUserByRoleID, Common.LookupsFK.Fk_RoleClinicianID);
        const clinicainData = clinicain.data.result
        let clinicainOption = clinicainData.map(v => (
            <option key={v.key} value={v.key}>{v.value}</option>
        ));
        this.setState({ selectClinicianOptions: clinicainOption })
        var outsSpecialist = await Api.getRequestById(Api.Uri_GetUserByRoleID, Common.LookupsFK.Fk_OutsID);
        const outsSpecialistData = outsSpecialist.data.result
        let outsSpecialistOption = outsSpecialistData.map(v => (
            <option key={v.key} value={v.key}>{v.value}</option>
        ));
        this.setState({ selectOutsSpecialistOptions: outsSpecialistOption })
        var enteralSpecialist = await Api.getRequestById(Api.Uri_GetUserByRoleID, Common.LookupsFK.Fk_EnteralID);
        const enteralSpecialistData = enteralSpecialist.data.result
        let enteralSpecialistOption = enteralSpecialistData.map(v => (
            <option key={v.key} value={v.key}>{v.value}</option>
        ));
        this.setState({ selectEnteralSpecialistOptions: enteralSpecialistOption })
    }
    getChainByOrgID(e) {
        Common.updateInputValueInState(this.state.Facilty, e, this, this.state);
        var orgID = this.state.Facilty.fkOrgId;
        Api.getRequestById(Api.Uri_GetChainByOrgID, orgID)
            .then((response) => {
                const data = response.data.result;
                let optionTemplate = data.map((v) => (
                    <option key={v.key} value={v.key}>
                        {v.value}
                    </option>
                ));
             //   this.setState({ selectOrgOptions: optionTemplate });
            })

    }
    handleCloseAdd = () => { this.setState({ addBtPhysicianModal: false }) };
    handleShowAddBrightreePhysician = () => {

        this.setState({
            addBtPhysicianComponent: <NewBrightreePhysician close={this.handleCloseAdd}
                selectPhysician={this.selectPhysician} />
        })
        this.setState({ addBtPhysicianModal: true })
    };
    selectPhysician = (obj) => {
        // Common.withOutEventUpdateInputValueInState(this.state.Resident, this, this.state, obj.brightreeId, "fkPrimaryPhysicianId")
        // Common.withOutEventUpdateInputValueInState(this.state.Resident, this, this.state, (obj.lastName+" "+obj.firstName), "primaryPhysicianName")
        var _selectedPhysician = this.state.Facilty;
        _selectedPhysician.physicianViewModel = obj;
        _selectedPhysician.fkPhysicianId = null
        _selectedPhysician.physicianName = Common.replaceNullWithString(obj.lastName) + " " + Common.replaceNullWithString(obj.firstName);
        this.setState({ Facilty: _selectedPhysician })
        Common.showSuccessAlert("Physician selected successfully", "success", "Success!", 3000);

    }
    //#region Get States
    getAllState() {
        Api.getRequest(Api.Uri_GetState)
            .then((res) => {
                if (res.data.statusCode == 200) {
                    if (res.data.result != null) {
                        if (res.data.result.length > 0) {
                            this.setState({ states: res.data.result });
                        }
                    }
                }
            })
            .catch((ex) => {
                Common.LogError(ex, "Facility", "NewFacility");

            });
    }
    setOptionsUI(options) {
        return options.map((option) => (
            <option key={option.key} value={option.key}>
                {option.value}
            </option>
        ));
    }
    //#endregion
    onSubmit() {    
        let fkChainId = this.state.Facilty.fkChainId;

        // Explicitly set to null if not selected
        if (fkChainId === "N/A" || fkChainId === "") {
            fkChainId = null;
        }
        let fkOrgId = this.state.Facilty.fkOrgId;

        // Explicitly set to null if not selected
        if (fkOrgId === "N/A" || fkOrgId === "") {
            fkOrgId = null;
        }
        const obj = this.state.Facilty;
        obj.fkChainId = fkChainId;
        obj.fkOrgId = fkOrgId; 

        if (this.form.checkValidity() === false) {
            // this.form.preventDefault();
            // this.form.stopPropagation();
            let _state = this.state;
            _state.formValidated = true;
            this.setState(_state);
        } else {

            const obj = this.state.Facilty;
            var postalCode = Common.isValidZipCode(obj.address.zip)
            if (!postalCode && obj.address.zip != "") {
                Common.showSuccessAlert("The value is NOT a valid US Zip code", "warning", "Warning!", 3000);
                return false;
            }
            this.setState({ IsLoading: false });
            obj.centerSupplyPersonPhone =
                Common.replaceNullWithString(obj.centerSupplyPersonPhone) != ""
                    ? obj.centerSupplyPersonPhone.replace(/[^0-9]/g, "").substr(0, 10)
                    : null;
            obj.partBrecPersonPhone = Common.replaceNullWithString(obj.partBrecPersonPhone) != ""
                ? obj.partBrecPersonPhone.replace(/[^0-9]/g, "").substr(0, 10)
                : null;

            obj.address.phone1 = Common.replaceNullWithString(obj.address.phone1) != ""
                ? obj.address.phone1.replace(/[^0-9]/g, "").substr(0, 10)
                : null;

            obj.address.fax = Common.replaceNullWithString(obj.address.fax) != ""
                ? obj.address.fax.replace(/[^0-9]/g, "").substr(0, 10)
                : null;

           // obj.BillTypeEnteral = this.state.Facilty.BillTypeEnteral;
            //obj.BillTypeOuts = this.state.Facilty.BillTypeOuts;
            if (this.state.Facilty.email && !Common.isValidEmail(this.state.Facilty.email)) {
                Common.showSuccessAlert("Please enter a valid email address", "warning", "Warning!", 3000);
                this.setState({ IsLoading: true });
                return false;
            }

            Api.postRequest(Api.Uri_AddFacility, obj).then((res) => {
                if (res.data.success) {
                    this.props.onSaveAPI();
                    this.setState({ IsLoading: true });
                    Common.showSuccessAlertAutoClose(
                        "Data Saved Successfully",
                        "success",
                        "Success!",
                        3000
                    );
                } else {
                    Common.showSuccessAlert(
                        res.data.message,
                        "error",
                        "Error!",
                        3000
                    );
                }
            });
        }
    }
    onOutsSpecialistChange = (e) => {
        const value = e.target.value === "" ? null : e.target.value;
        const updatedFacilty = {
            ...this.state.Facilty,
            [e.target.name]: value
        };
        this.setState({ Facilty: updatedFacilty });
    }

    onEnteralSpecialistChange = (e) => {
        const value = e.target.value === "" ? null : e.target.value;
        const updatedFacilty = {
            ...this.state.Facilty,
            [e.target.name]: value
        };
        this.setState({ Facilty: updatedFacilty });
    }
    setNpiValue = (e) => {
        var npi = e.target.value;
        if (npi.length < 11) {

            Common.updateInputValueInState(
                this.state.Facilty,
                e,
                this,
                this.state
            )

        }

    }
    onProductSpecialistChange = (e) => {
        Common.updateInputValueInState(
            this.state.Facilty,
            e,
            this,
            this.state
        )
        this.setState({ manager: '', vicePresident: '' });

        if (e.target.value > 1) {
            this.getRegionalManagerAndVicePresident(e.target.value);
        }

    }
    onBillTypeOutsChange = (e) => {
        const value = e.target.value === "" ? null : e.target.value;
        const updatedFacilty = {
            ...this.state.Facilty,
            [e.target.name]: value
        };
        this.setState({ Facilty: updatedFacilty });
    }
    onBillTypeEnteralChange = (e) => {
        const value = e.target.value === "" ? null : e.target.value;
        const updatedFacilty = {
            ...this.state.Facilty,
            [e.target.name]: value
        };
        this.setState({ Facilty: updatedFacilty });
    }
    //getRegionalManagerAndVicePresident = (userID) => {
    //    Api.getRequestQry(Api.Uri_GetRegionalManagerAndVicePresident, "?userID=" + userID)
    //        .then((response) => {

    //            if (response.data.result.length > 0) {
    //                for (var i = 0; i < response.data.result.length; i++) {
    //                    var usr = response.data.result[i];
    //                    if (usr.managerType == "Manager") {
    //                        this.setState({ manager: usr.lastName + ' ' + usr.firstName });
    //                    } else if (usr.managerType == "VicePresident") {
    //                        this.setState({ vicePresident: usr.lastName + ' ' + usr.firstName });

    //                    }
    //                }

    //            }

    //            // this.setState({ selectOrgOptions: optionTemplate });
    //        })

    //}
    //getAllActiveEMR() {

    //    Api.getRequestQry(Api.apiUrls.getAllEMR, "?isActive=" + 1)
    //        .then((res) => {
    //            if (res.data.statusCode == 200) {
    //                if (res.data.result != null) {
    //                    if (res.data.result.length > 0) {
    //                        this.setState({
    //                            selectGroupPurchasingOptions: res.data.result
    //                        });
    //                    }
    //                }
    //            }
    //        })
    //        .catch((ex) => { });
    //}
    //setAllEMR = (users) => {
    //    return users.map((usr) => (
    //        <option key={usr.id} value={usr.id}>
    //            {usr.name}
    //        </option>
    //    ));
//}

getRegionalManagerAndVicePresident = (userID) => {
    Api.getRequestQry(Api.Uri_GetRegionalManagerAndVicePresident, "?userID=" + userID)
        .then((response) => {

            if (response.data.result.length > 0) {
                for (var i = 0; i < response.data.result.length; i++) {
                    var usr = response.data.result[i];
                    if (usr.managerType == "Manager") {
                        this.setState({ manager: usr.lastName + ' ' + usr.firstName });
                    } else if (usr.managerType == "VicePresident") {
                        this.setState({ vicePresident: usr.lastName + ' ' + usr.firstName });

                    }
                }

            }

            // this.setState({ selectOrgOptions: optionTemplate });
        })

}
getAllActiveEMR() {

    Api.getRequestQry(Api.apiUrls.getAllEMR, "?isActive=" + 1)
        .then((res) => {
            if (res.data.statusCode == 200) {
                if (res.data.result != null) {
                    if (res.data.result.length > 0) {
                        this.setState({
                            selectGroupPurchasingOptions: res.data.result
                        });
                    }
                }
            }
        })
        .catch((ex) => { });
}
    setAllEMR = (users) => {
        return [
            <option key="" value="">Select EMR System</option>,
            ...users.map((usr) => (
                <option key={usr.id} value={usr.id}>
                    {usr.name}
                </option>
            ))
        ];
    };

    showEditEMR = async (id) => {


        var findEmr = this.state.selectGroupPurchasingOptions.find(x => x.id == this.state.Facilty.fkGroupPurchasingOrg)
        // await setEMR(obj);
        if (findEmr != undefined) {
            findEmr.isCredentailUpdate = true;
            this.setState({ emr: findEmr })
            emrModal.showModal();
        }

    };
    onEMRFormSubmit = () => {
        emrModal.hideModal();
        //getHeaderValue() ;
        Common.showSuccessAlertAutoClose("EMR Saved successful", "success", "Success!", 3000);
        this.getAllActiveEMR();
    }
    SyncFacilityGroup = () => {
        Api.getRequest(Api.apiUrls.fetchFacilityGroups)
            .then((res) => {
                if (res.data.statusCode == 200) {
                    Common.showSuccessAlert("Facility Group Fetch Successful", "success", "Success!", 3000);
                }
            })
            .catch((ex) => {
                Common.LogError(ex, "Facility", "NewFacility");

            });
    }
    loadPhysicians = async (inputValue) => {
        try {
            if (inputValue.length > 1) {

                var { data } = await Api.getRequestQry(
                    Api.apiUrls.doctorsSearch, `?searchTerm=${inputValue}`
                );
                if (data.success) {
                    let orgList = [];
                    if (data.result.length) {
                        orgList = data.result;
                    }
                    this.setState({ physicianList: orgList })
                    // setOrganizations(orgList)
                    return orgList.map((e) => {
                        return {
                            label: e.lastName + " " + e.firstName,
                            value: e.brightreeId
                        }
                    });
                }
            }
            return [];
        } catch (error) {
            return [];
        }
    };
    setPhysicianInputValue = async (value) => {
        // this.setState({physiciansInputValue:value})
        this.setState({ physiciansInputValue: value });
    }
    setPhysician = (physician) => {
        this.setState({ physician: physician });
        var _selectedPhysician = this.state.Facilty;
        if (physician != null) {
            var obj = this.state.physicianList.find(x => x.brightreeId == physician.value)
            _selectedPhysician.physicianViewModel = obj;
            _selectedPhysician.fkPhysicianId = null
            _selectedPhysician.physicianName = Common.replaceNullWithString(obj.lastName) + " " + Common.replaceNullWithString(obj.firstName);
        } else {

            _selectedPhysician.physicianViewModel = null;
            _selectedPhysician.fkPhysicianId = null;
            _selectedPhysician.physicianName = ''
        }

        this.setState({ Facilty: _selectedPhysician })
    }
    render() {
        return (
            <>
                {this.state.addBtPhysicianModal && <Animated animationIn="fadeInLeft" animationInDuration={1000}>

                    {this.state.addBtPhysicianComponent}

                </Animated>}
                {!this.state.addBtPhysicianModal && <Animated animationIn="fadeInLeft" animationInDuration={1000}>

                    {(this.state.IsLoading == true) ?
                        <div>
                            <Form
                                ref={(ref) => {
                                    this.form = ref;
                                }}
                                validated={this.state.formValidated}
                                onSubmit={(e) => this.onSubmit(e)}
                            >
                                <>
                                    <fieldset className="p-2 mb-2 bg-light border border-dark rounded">
                                        <legend className="text-primary fw-500">Basic Information:</legend>
                                        <div className="row">
                                            <div className="col-sm-6 col-md-4 col-lg-4 col-xl-3 d-flex">
                                                <div className="form-group h-100 d-flex flex-column w-100">
                                                    <label className="form-label" htmlFor="FacilityName">
                                                        Facility Name
                                                    </label>
                                                    <input
                                                        type="text"
                                                        id="FacilityName"
                                                        name="facilityName"
                                                        required
                                                        defaultValue={this.state.Facilty.facilityName}

                                                        onChange={(e) =>
                                                            Common.updateInputValueInState(
                                                                this.state.Facilty,
                                                                e,
                                                                this,
                                                                this.state
                                                            )
                                                        }
                                                        className="form-control form-control-sm"
                                                    />
                                                </div>
                                            </div>
                                            <div className="col-sm-6 col-md-4 col-lg-4 col-xl-3 d-flex">
                                                <div className="form-group h-100 d-flex flex-column w-100">
                                                    <label className="form-label" htmlFor="ThisFacilityBelongsTo">
                                                        Ownership-Headquarters
                                                        <button type="button" className="btn btn-success ml-2 py-0 px-1 small"

                                                            onClick={() => { facilityGroupModal.showModal(); this.setState({ isHeadquarters: false }) }}
                                                        >
                                                            Add
                                                        </button>
                                                    </label>
               
                                                    <div className="input-group">
                                                        <select
                                                            className="form-control form-control-sm"
                                                            id="fkOrgId"
                                                            name="fkOrgId"
                                                            onChange={(e) => this.getChainByOrgID(e)}
                                                            value={this.state.Facilty.fkOrgId}

                                                        >
                                                            <option value="N/A">Select Organization</option>
                                                            {this.state.selectOrgOptions}
                                                        </select>
                                                        <CheckPermission
                                                            userRole={RBAC.Role_Gentell_Administrator}
                                                            yes={() => (
                                                                <>
                                                                    <div className="input-group-append"><button
                                                                        type="button"
                                                                        onClick={() => { this.SyncFacilityGroup() }}
                                                                        className="btn btn-secondary btn-sm h-100">Sync</button>
                                                                    </div>
                                                                </>
                                                            )}
                                                            no={() => null}
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-sm-6 col-md-4 col-lg-4 col-xl-3 d-flex">
                                                <div className="form-group h-100 d-flex flex-column w-100">
                                                    <label className="form-label" htmlFor="ThisFacilityBelongsTo">
                                                        Purchasing Group-Chain
                                                        <button type="button" className="btn btn-success ml-2 py-0 px-1 small"

                                                            onClick={() => { facilityGroupModal.showModal(); this.setState({ isHeadquarters: true }) }}
                                                        >
                                                            Add
                                                        </button>
                                                    </label>
                                                    <select
                                                        className="form-control form-control-sm"
                                                        name="fkChainId"
                                                        value={this.state.Facilty.fkChainId}
                                                        onChange={(e) =>
                                                            Common.updateInputValueInState(
                                                                this.state.Facilty,
                                                                e,
                                                                this,
                                                                this.state
                                                            )
                                                        }
                                                    >
                                                        <option value="N/A">Select Chain</option>
                                                        {this.state.selectOrgChainOptions}
                                                    </select>
                                                </div>
                                            </div>
                                            <div className="col-sm-6 col-md-4 col-lg-4 col-xl-3 d-flex">
                                                <div className="form-group h-100 d-flex flex-column w-100">
                                                    <label className="form-label" htmlFor="FacilityType">
                                                        Facility Type
                                                    </label>
                                                    <select
                                                        className="form-control form-control-sm"
                                                        name="fkFacilityTypeId"
                                                        required
                                                        defaultValue={this.state.Facilty.fkFacilityTypeId}

                                                        onChange={(e) =>
                                                            Common.updateInputValueInState(
                                                                this.state.Facilty,
                                                                e,
                                                                this,
                                                                this.state
                                                            )
                                                        }
                                                    >
                                                        <option ></option>
                                                        {this.state.selectFacilityTypeOptions}
                                                    </select>
                                                </div>
                                            </div>
                                            <div className="col-12 col-sm-6 col-md-4 col-xl-3">
                                                <div className="form-group">
                                                    <label className="form-label" htmlFor="NPINumber">
                                                        NPI #:
                                                    </label>
                                                    <input
                                                        type="number"
                                                        id="NPINumber"
                                                        name="npi"
                                                        defaultValue={this.state.Facilty.npi}
                                                        onKeyDown={(evt) => ["e", "E", "+", "-"].includes(evt.key) && evt.preventDefault()}
                                                        onChange={e => this.setNpiValue(e)}
                                                        className="form-control form-control-sm"
                                                    />
                                                </div>
                                            </div>
                                            
                                            <div className="col-12 col-sm-6 col-md-4 col-xl-3">
                                                <div className="form-group">
                                                    <label className="form-label" htmlFor="NumberofBeds">
                                                        Number of Beds
                                                    </label>
                                                    <input
                                                        type="number"
                                                        id="NumberofBeds"
                                                        name="numberofBeds"
                                                        min="0"
                                                        step="1"
                                                        inputMode="numeric"
                                                        pattern="[0-9]*"
                                                        className="form-control form-control-sm"
                                                        defaultValue={this.state.Facilty.numberofBeds}
                                                        onKeyDown={(e) => ["e", "E", "+", "-"].includes(e.key) && e.preventDefault()}
                                                        onChange={(e) =>
                                                            Common.updateInputValueInState(
                                                                this.state.Facilty,
                                                                e,
                                                                this,
                                                                this.state
                                                            )
                                                        }
                                                        className="form-control form-control-sm"
                                                    />
                                                </div>
                                            </div>
                                            <div className="col-12 col-sm-6 col-md-4 col-xl-3">
                                                <div className="form-group">
                                                    <label
                                                        className="form-label"
                                                        htmlFor="Shipsfromthiswarehouse:"
                                                    >
                                                        Ships from warehouse
                                                    </label>
                                                    <select
                                                        className="form-control form-control-sm"
                                                        name="fkWarehouseId"
                                                        defaultValue={this.state.Facilty.fkWarehouseId}

                                                        onChange={(e) =>
                                                            Common.updateInputValueInState(
                                                                this.state.Facilty,
                                                                e,
                                                                this,
                                                                this.state
                                                            )
                                                        }
                                                    >
                                                        <option></option>
                                                        {this.state.selectWarehouseOption}
                                                    </select>
                                                </div>
                                            </div>
                                            <div className="col-12 col-sm-6 col-md-4 col-xl-3">
                                                <div className="form-group">
                                                    <label className="form-label" htmlFor="FacilityType">
                                                        Wound and Product Specialist
                                                    </label>
                                                    <select
                                                        className="form-control form-control-sm"
                                                        name="fkClinicianId"
                                                        defaultValue={this.state.Facilty.fkClinicianId}
                                                        onChange={(e) =>
                                                            this.onProductSpecialistChange(e)
                                                        }
                                                    >
                                                        <option></option>
                                                        {this.state.selectClinicianOptions}
                                                    </select>
                                                </div>
                                            </div>
                                            <div className="col-12 col-sm-6 col-md-4 col-xl-3">
                                                <div className="form-group">
                                                    <label className="form-label" htmlFor="FacilityType">
                                                        Regional Manager
                                                    </label>
                                                    <input
                                                        type="text"
                                                        disabled
                                                        defaultValue={this.state.manager}


                                                        className="form-control form-control-sm"
                                                    />

                                                </div>
                                            </div>
                                            <div className="col-12 col-sm-6 col-md-4 col-xl-3">
                                                <div className="form-group">
                                                    <label className="form-label" htmlFor="FacilityType">
                                                        OUTs Account Specialist
                                                    </label>
                                                    <select
                                                        className="form-control form-control-sm"
                                                        name="fK_OutsID"
                                                        disabled={this.props.roles.roleList.find(x => x.roleName == RBAC.Role_Gentell_Administrator) == undefined}
                                                        // required
                                                        value={this.state.Facilty.fK_OutsID}
                                                        onChange={(e) =>
                                                            this.onOutsSpecialistChange(e)
                                                        }
                                                    >
                                                        <option value="">Select OUTs Specialist</option>
                                                        {this.state.selectOutsSpecialistOptions}
                                                    </select>
                                                </div>
                                            </div>
                                            <div className="col-12 col-sm-6 col-md-4 col-xl-3">
                                                <div className="form-group">
                                                    <label className="form-label" htmlFor="FacilityType">
                                                        Enteral Account Specialist
                                                    </label>
                                                    <select
                                                        className="form-control form-control-sm"
                                                        name="fK_EnteralID"
                                                        disabled={this.props.roles.roleList.find(x => x.roleName == RBAC.Role_Gentell_Administrator) == undefined}
                                                        // required
                                                        value={this.state.Facilty.fK_EnteralID}
                                                        onChange={(e) =>
                                                            this.onEnteralSpecialistChange(e)
                                                        }
                                                    >
                                                        <option value="">Select Enteral Specialist </option>
                                                        {this.state.selectEnteralSpecialistOptions}
                                                    </select>
                                                </div>
                                            </div>
                                            <div className="col-12 col-sm-6 col-md-4 col-xl-3">
                                                <div className="form-group">
                                                    <label className="form-label" htmlFor="MemberofGroupPurchasingOrg.">EMR System</label>
                                                    <div className="input-group">
                                                        <select
                                                            className="form-control form-control-sm"
                                                            name="fkGroupPurchasingOrg"
                                                            disabled={
                                                                this.props.roles.roleList.find(x => x.roleName == RBAC.Role_Gentell_Administrator) == undefined
                                                                && this.props.roles.roleList.find(x => x.roleName == RBAC.Role_Gentell_WoundCareSpecialist) == undefined
                                                                && this.props.roles.roleList.find(x => x.roleName == RBAC.Role_Gentell_RegionalManager) == undefined
                                                                && this.props.roles.roleList.find(x => x.roleName == RBAC.Role_Gentell_IntakeProcessor) == undefined
                                                                && this.props.roles.roleList.find(x => x.roleName == RBAC.Role_Gentell_SeniorBiller) == undefined
                                                                && this.props.roles.roleList.find(x => x.roleName == RBAC.Role_Gentell_OutsSpecialist) == undefined
                                                                && this.props.roles.roleList.find(x => x.roleName == RBAC.Role_Gentell_EnteralSpecialist) == undefined
                                                            }

                                                            value={Common.replaceNullWithString(this.state.Facilty.fkGroupPurchasingOrg)}
                                                            onChange={e => {
                                                                const selectedValue = parseInt(e.target.value);

                                                                // Update the state with the new value and handle the websiteAddress change
                                                                this.setState(prevState => {
                                                                    let websiteAddress = prevState.Facilty.websiteAddress;
                                                                    if (selectedValue !== 2) {
                                                                        websiteAddress = "";  // Reset for other values (not 2)
                                                                    }

                                                                    return {
                                                                        Facilty: {
                                                                            ...prevState.Facilty,
                                                                            fkGroupPurchasingOrg: selectedValue,
                                                                            websiteAddress: websiteAddress,
                                                                        }
                                                                    };
                                                                });
                                                            }}
                                                        >
                                                            {this.setAllEMR(this.state.selectGroupPurchasingOptions)}
                                                        </select>
                                                    </div>
                                                </div>
                                            </div>

                                            <div className="col-12 col-sm-6 col-md-4 col-xl-3">
                                                <div className="form-group">
                                                    <label className="form-label" htmlFor="WebSiteAddress">
                                                        Account Name
                                                    </label>
                                                    <input
                                                        name="websiteAddress"
                                                        required
                                                        value={this.state.Facilty.websiteAddress || ""}
                                                        disabled={
                                                            this.state.Facilty.fkGroupPurchasingOrg !== 2 ||
                                                            this.props.roles.roleList.find(x => x.roleName == RBAC.Role_Gentell_OutsSpecialist) != undefined ||
                                                            this.props.roles.roleList.find(x => x.roleName == RBAC.Role_Gentell_EnteralSpecialist) != undefined
                                                        }
                                                        onChange={(e) =>
                                                            Common.updateInputValueInState(
                                                                this.state.Facilty,
                                                                e,
                                                                this,
                                                                this.state
                                                            )
                                                        }
                                                        className="form-control form-control-sm"
                                                    />
                                                </div>
                                            </div>

                                            
                                            <CheckPermission
                                                userRole={RBAC.Role_Gentell_Administrator}
                                                yes={() => (
                                                    <>
                                                        <div className="col-12 col-sm-6 col-md-4 col-xl-3">
                                                            <div className="form-group">
                                                                <label className="form-label" htmlFor="doB">
                                                                    User ID
                                                                </label>
                                                                <input
                                                                    type="text"
                                                                    id="emrlogin"
                                                                    className="form-control form-control-sm"
                                                                    name="emrlogin"
                                                                    defaultValue={
                                                                        this.state.Facilty.emrlogin
                                                                    }
                                                                    onChange={(e) =>
                                                                        Common.updateInputValueInState(
                                                                            this.state.Facilty,
                                                                            e,
                                                                            this,
                                                                            this.state
                                                                        )
                                                                    }
                                                                />
                                                            </div>
                                                        </div>
                                                        <div className="col-12 col-sm-6 col-md-4 col-xl-3">
                                                            <div className="form-group">
                                                                <label className="form-label" htmlFor="doB">
                                                                    Password
                                                                </label>
                                                                <input
                                                                    type="text"
                                                                    id="emrpassword"
                                                                    className="form-control form-control-sm"
                                                                    name="emrpassword"
                                                                    defaultValue={
                                                                        this.state.Facilty.emrpassword
                                                                    }
                                                                    onChange={(e) =>
                                                                        Common.updateInputValueInState(
                                                                            this.state.Facilty,
                                                                            e,
                                                                            this,
                                                                            this.state
                                                                        )
                                                                    }
                                                                />
                                                            </div>
                                                        </div>
                                                    </>
                                                )}
                                                no={() => null}
                                            />
                                            <div className="col-12 col-sm-6 col-md-4 col-lg-3 d-flex align-items-center">
                                                <label className="checkbox m-0 d-flex align-items-center">
                                                    <input
                                                        type="checkbox"
                                                        name="isEmr"
                                                        checked={this.state.Facilty.isEmr}
                                                        onChange={(e) =>
                                                            Common.updateInputValueInState(this.state.Facilty, e, this, this.state)
                                                        }
                                                        className="m-1"
                                                        disabled={
                                                            !this.props.roles.roleList.some((x) =>
                                                                [
                                                                    RBAC.Role_Gentell_Administrator,
                                                                    RBAC.Role_Gentell_WoundCareSpecialist,
                                                                    RBAC.Role_Gentell_RegionalManager,
                                                                    RBAC.Role_Gentell_OutsSpecialist,
                                                                    RBAC.Role_Gentell_EnteralSpecialist,
                                                                ].includes(x.roleName)
                                                            )
                                                        }
                                                    />
                                                    <span className="mr-2" />
                                                    Use EMR for Billing
                                                </label>
                                            </div>
                                          
                                        </div>
                                    </fieldset>
                                    <fieldset className="p-2 mb-2 bg-light border border-dark rounded">
                                        <legend className="text-primary fw-500">Address Information</legend>
                                        <div className="row">
                                            <div className="col-sm-6 col-md-4 col-lg-4 col-xl-3">
                                                <div className="form-group">
                                                    <label className="form-label" htmlFor="Memo">
                                                        Address Line 1
                                                    </label>
                                                    <input
                                                        type="text"
                                                        id="address1"
                                                        name="addressLine1"
                                                        defaultValue={this.state.Facilty.address.addressLine1}
                                                        onChange={(e) =>
                                                            Common.updateInputValueInState(
                                                                this.state.Facilty.address,
                                                                e,
                                                                this,
                                                                this.state
                                                            )
                                                        }
                                                        className="form-control form-control-sm"
                                                    ></input>
                                                </div>
                                            </div>

                                            <div className="col-sm-6 col-md-4 col-lg-4 col-xl-3">
                                                <div className="form-group">
                                                    <label className="form-label" htmlFor="Memo">
                                                        Address Line 2
                                                    </label>
                                                    <input
                                                        type="text"
                                                        id="addressLine2"
                                                        name="addressLine2"
                                                        defaultValue={this.state.Facilty.address.addressLine2}
                                                        onChange={(e) =>
                                                            Common.updateInputValueInState(
                                                                this.state.Facilty.address,
                                                                e,
                                                                this,
                                                                this.state
                                                            )
                                                        }
                                                        className="form-control form-control-sm"
                                                    ></input>
                                                </div>
                                            </div>



                                            <div className="col-sm-6 col-md-4 col-lg-4 col-xl-3">
                                                <div className="form-group">
                                                    <label className="form-label" htmlFor="City">
                                                        City
                                                    </label>
                                                    <input
                                                        type="text"
                                                        id="City"
                                                        name="city"
                                                        defaultValue={this.state.Facilty.address.city}
                                                        onChange={(e) =>
                                                            Common.updateInputValueInState(
                                                                this.state.Facilty.address,
                                                                e,
                                                                this,
                                                                this.state
                                                            )
                                                        }
                                                        className="form-control form-control-sm"
                                                    />
                                                </div>
                                            </div>
                                            <div className="col-sm-6 col-md-4 col-lg-4 col-xl-3">
                                                <div className="form-group">
                                                    <label className="form-label" htmlFor="State">
                                                        State
                                                    </label>
                                                    <select
                                                        className="form-control form-control-sm"
                                                        name="stateId"
                                                        required
                                                        defaultValue={this.state.Facilty.address.stateId}
                                                        onChange={(e) =>
                                                            Common.updateInputValueInState(
                                                                this.state.Facilty.address,
                                                                e,
                                                                this,
                                                                this.state
                                                            )
                                                        }
                                                    >
                                                        <option></option>
                                                        {this.setOptionsUI(this.state.states)}
                                                    </select>
                                                </div>
                                            </div>
                                        </div>

                                        <div className="row">



                                            <div className="col-sm-3 col-md-4 col-lg-4 col-xl-3">
                                                <div className="form-group">
                                                    <label className="form-label" htmlFor="Phone1">
                                                        Postal code
                                                    </label>
                                                    <input
                                                        type="number"
                                                        id="Zip"
                                                        name="zip"
                                                        minLength="5" maxLength="9"
                                                        defaultValue={this.state.Facilty.address.zip}
                                                        onKeyDown={(evt) => ["e", "E", "+", "-"].includes(evt.key) && evt.preventDefault()}
                                                        onChange={(e) =>
                                                            Common.updateInputValueInState(
                                                                this.state.Facilty.address,
                                                                e,
                                                                this,
                                                                this.state
                                                            )
                                                        }
                                                        className="form-control form-control-sm"
                                                    />
                                                </div>
                                            </div>
                                            <div className="col-sm-6 col-md-4 col-lg-4 col-xl-3">
                                                <div className="form-group">
                                                    <label className="form-label" htmlFor="Country">
                                                        Country
                                                    </label>
                                                    <select
                                                        className="form-control form-control-sm"
                                                        name="countryId"
                                                        defaultValue={this.state.Facilty.address.countryId}

                                                        onChange={(e) =>
                                                            Common.updateInputValueInState(
                                                                this.state.Facilty.address,
                                                                e,
                                                                this,
                                                                this.state
                                                            )
                                                        }
                                                        id="State"
                                                    >
                                                        <option value="1">United States</option>
                                                    </select>
                                                </div>
                                            </div>
                                            <div className="col-sm-6 col-md-4 col-lg-4 col-xl-3">
                                                <div className="form-group">
                                                    <label className="form-label" htmlFor="Phone1">
                                                        Phone
                                                    </label>
                                                    <input
                                                        type="phone"
                                                        id="Phone1"
                                                        name="phone1"
                                                        value={Common.getFormattedPhoneNum(this.state.Facilty.address.phone1)}
                                                        onChange={(e) =>
                                                            Common.updateInputValueInState(
                                                                this.state.Facilty.address,
                                                                e,
                                                                this,
                                                                this.state
                                                            )
                                                        }
                                                        className="form-control form-control-sm"
                                                    />
                                                </div>
                                            </div>
                                            <div className="col-sm-6 col-md-4 col-lg-4 col-xl-3">
                                                <div className="form-group">
                                                    <label className="form-label" htmlFor="Phone1">
                                                        Fax
                                                    </label>
                                                    <input
                                                        type="text"
                                                        id="Fax"
                                                        name="fax"
                                                        value={Common.getFormattedPhoneNum(this.state.Facilty.address.fax)}
                                                        onChange={(e) =>
                                                            Common.updateInputValueInState(
                                                                this.state.Facilty.address,
                                                                e,
                                                                this,
                                                                this.state
                                                            )
                                                        }
                                                        className="form-control form-control-sm"
                                                    />
                                                </div>
                                            </div>
                                           
                                            {/* End Address */}
                                        </div>
                                    </fieldset>
                                    <fieldset className="p-2 mb-2 bg-light border border-dark rounded">
                                        <legend className="text-primary fw-500">Other Information</legend>
                                        <div className="row">
                                            <div className="col-sm-12 col-md-12 col-lg-5 col-xl-4">
                                                <ul className="list-unstyled my-5 border-dark border-md-0 border-right-lg">
                                                    <li className="mb-3">
                                                        <label className="checkbox">
                                                            <input
                                                                type="checkbox"
                                                                name="medicarePartBbyGentell"
                                                                checked={this.state.Facilty.medicarePartBbyGentell}
                                                                onChange={(e) =>

                                                                    Common.updateInputValueInState(
                                                                        this.state.Facilty,
                                                                        e,
                                                                        this,
                                                                        this.state
                                                                    )
                                                                }
                                                                className="m-1"
                                                            />
                                                            <span className="mr-3" />
                                                            Wound Care Part B
                                                        </label>
                                                    </li>
                                                    <li className="mb-3">
                                                        <label className="checkbox">
                                                            <input
                                                                type="checkbox"
                                                                name="outProgram"
                                                                checked={this.state.Facilty.outProgram}

                                                                onChange={(e) =>
                                                                    Common.updateInputValueInState(
                                                                        this.state.Facilty,
                                                                        e,
                                                                        this,
                                                                        this.state
                                                                    )
                                                                }
                                                                className="m-1"
                                                            />
                                                            <span className="mr-3" />
                                                            OUTs Part B
                                                        </label>
                                                    </li>
                                                    {this.state.Facilty.outProgram && (
                                                        <div className='pl-3 pr-8 mb-3'>
                                                            <select className="form-control form-control-sm"
                                                                name="fkOutProgramWarehouse"
                                                                onChange={e => Common.updateInputValueInState(this.state.Facilty, e, this, this.state)}
                                                                id="fkOutProgramWarehouse"
                                                                value={this.state.Facilty.fkOutProgramWarehouse}>
                                                                <option value={33}>Bristol</option>
                                                                <option value={34}>Chicago</option>
                                                            </select>
                                                        </div>
                                                    )}
                                                    {this.state.Facilty.outProgram && (
                                                        <div className='pl-3 pr-8 mb-3'>
                                         
                                                            <select
                                                                className="form-control form-control-sm"
                                                                name="BillTypeOuts"
                                                                value={this.state.Facilty.BillTypeOuts || ""}
                                                                disabled={this.props.roles.roleList.find(x => x.roleName == RBAC.Role_Gentell_Administrator) == undefined}
                                                                onChange={this.onBillTypeOutsChange}
                                                            >
                                                                <option value="">Select Bill Type</option>
                                                                {this.state.billTypeOptions.map(opt => (
                                                                    <option key={opt.key} value={opt.value}>
                                                                        {opt.value}
                                                                    </option>
                                                                ))}
                                                            </select>
                                                        </div>
                                                    )}
                                                    <li className="mb-3">
                                                        <label className="checkbox">
                                                            <input
                                                                type="checkbox"
                                                                name="IsEcp"
                                                                checked={this.state.Facilty.IsEcp}

                                                                onChange={(e) =>
                                                                    Common.updateInputValueInState(
                                                                        this.state.Facilty,
                                                                        e,
                                                                        this,
                                                                        this.state
                                                                    )
                                                                }
                                                                className="m-1"
                                                            />
                                                            <span className="mr-3" />
                                                            Equal Care Program
                                                        </label>
                                                    </li>
                                                    <li className="mb-3">
                                                        <label className="checkbox">
                                                            <input
                                                                type="checkbox"
                                                                name="isThisFacilityFollowingTheCycle"
                                                                checked={this.state.Facilty.isThisFacilityFollowingTheCycle}

                                                                onChange={(e) =>
                                                                    Common.updateInputValueInState(
                                                                        this.state.Facilty,
                                                                        e,
                                                                        this,
                                                                        this.state
                                                                    )
                                                                }
                                                                className="m-1"
                                                            />
                                                            <span className="mr-3" />
                                                            Enteral Program
                                                        </label>
                                                    </li>
                                                    {this.state.Facilty.isThisFacilityFollowingTheCycle && (
                                                        <div className='pl-3 pr-8 mb-3'>
                                                            <select
                                                                className="form-control form-control-sm"
                                                                name="BillTypeEnteral"
                                                                value={this.state.Facilty.BillTypeEnteral || ""}
                                                                disabled={this.props.roles.roleList.find(x => x.roleName == RBAC.Role_Gentell_Administrator) == undefined}
                                                                onChange={this.onBillTypeEnteralChange}
                                                            >
                                                                <option value="">Select Bill Type</option>
                                                                {this.state.billTypeOptions.map(opt => (
                                                                    <option key={opt.key} value={opt.value}>
                                                                        {opt.value}
                                                                    </option>
                                                                ))}
                                                            </select>
                                                        </div>
                                                    )}
                                                    <li className="mb-3">
                                                        <label className="checkbox">
                                                            <input
                                                                type="checkbox"
                                                                name="canAddAssessment"
                                                                checked={this.state.Facilty.canAddAssessment}

                                                                onChange={(e) =>
                                                                    Common.updateInputValueInState(
                                                                        this.state.Facilty,
                                                                        e,
                                                                        this,
                                                                        this.state
                                                                    )
                                                                }
                                                                className="m-1"
                                                            />
                                                            <span className="mr-3" />
                                                            Facility use of Fastcare
                                                        </label>
                                                    </li>
                                                </ul>
                                            </div>
                                            <div className="col-sm-12 col-md-12 col-lg-7 col-xl-8">
                                                <div className="row">
                                                    <div className="col-sm-6 col-md-6 col-lg-6 col-xl-4">
                                                        <div className="form-group">
                                                            <label
                                                                className="form-label"
                                                                htmlFor="primaryBillingPerson"
                                                            >
                                                                Primary Billing Person
                                                            </label>
                                                            <input
                                                                type="text"
                                                                id="primaryBillingPerson"
                                                                name="primaryBillingPerson"
                                                                value={this.state.Facilty.primaryBillingPerson}
                                                                disabled={this.props.roles.roleList.find(x => x.roleName == RBAC.Role_Gentell_Administrator) == undefined
                                                                    && this.props.roles.roleList.find(x => x.roleName == RBAC.Role_Gentell_WoundCareSpecialist) == undefined
                                                                    && this.props.roles.roleList.find(x => x.roleName == RBAC.Role_Gentell_RegionalManager) == undefined
                                                                    && this.props.roles.roleList.find(x => RBAC.Role_Gentell_IntakeProcessor) == undefined
                                                                    && this.props.roles.roleList.find(x => RBAC.Role_Gentell_SeniorBiller) == undefined
                                                                    && this.props.roles.roleList.find(x => x.roleName == RBAC.Role_Gentell_OutsSpecialist) == undefined
                                                                    && this.props.roles.roleList.find(x => x.roleName == RBAC.Role_Gentell_EnteralSpecialist) == undefined}
                                                                onChange={(e) =>
                                                                    Common.updateInputValueInState(
                                                                        this.state.Facilty,
                                                                        e,
                                                                        this,
                                                                        this.state
                                                                    )
                                                                }
                                                                className="form-control form-control-sm"
                                                            />
                                                        </div>
                                                    </div>
                                                    <div className="col-sm-6 col-md-4 col-lg-4 col-xl-4">
                                                        <div className="form-group">
                                                            <label className="form-label" htmlFor="primaryBillingPhone1">
                                                               Primary Billing Person Phone #
                                                            </label>
                                                            <input
                                                                type="phone"
                                                                id="primaryBillingPersonPhone"
                                                                name="primaryBillingPersonPhone"
                                                                value={Common.replaceNullOrEmptyWithString(Common.getFormattedPhoneNum(this.state.Facilty.primaryBillingPersonPhone), "")}
                                                                disabled={this.props.roles.roleList.find(x => x.roleName == RBAC.Role_Gentell_Administrator) == undefined
                                                                    && this.props.roles.roleList.find(x => x.roleName == RBAC.Role_Gentell_WoundCareSpecialist) == undefined
                                                                    && this.props.roles.roleList.find(x => x.roleName == RBAC.Role_Gentell_RegionalManager) == undefined
                                                                    && this.props.roles.roleList.find(x => RBAC.Role_Gentell_IntakeProcessor) == undefined
                                                                    && this.props.roles.roleList.find(x => RBAC.Role_Gentell_SeniorBiller) == undefined
                                                                    && this.props.roles.roleList.find(x => x.roleName == RBAC.Role_Gentell_OutsSpecialist) == undefined
                                                                    && this.props.roles.roleList.find(x => x.roleName == RBAC.Role_Gentell_EnteralSpecialist) == undefined} onChange={(e) =>
                                                                        Common.updateInputValueInState(
                                                                            this.state.Facilty,
                                                                            e,
                                                                            this,
                                                                            this.state
                                                                        )
                                                                    }
                                                                className="form-control form-control-sm"
                                                            />
                                                        </div>
                                                    </div>


                                                    <div className="col-sm-6 col-md-4 col-lg-4 col-xl-4">
                                                        <div className="form-group">
                                                            <label className="form-label" htmlFor="primaryBillingPersonEmail">
                                                               Primary Billing Person Email
                                                            </label>
                                                            <input
                                                                type="phone"
                                                                id="primaryBillingPersonEmail"
                                                                name="primaryBillingPersonEmail"
                                                                value={Common.replaceNullOrEmptyWithString(this.state.Facilty.primaryBillingPersonEmail, "")}
                                                                disabled={this.props.roles.roleList.find(x => x.roleName == RBAC.Role_Gentell_Administrator) == undefined
                                                                    && this.props.roles.roleList.find(x => x.roleName == RBAC.Role_Gentell_WoundCareSpecialist) == undefined
                                                                    && this.props.roles.roleList.find(x => x.roleName == RBAC.Role_Gentell_RegionalManager) == undefined
                                                                    && this.props.roles.roleList.find(x => RBAC.Role_Gentell_IntakeProcessor) == undefined
                                                                    && this.props.roles.roleList.find(x => RBAC.Role_Gentell_SeniorBiller) == undefined
                                                                    && this.props.roles.roleList.find(x => x.roleName == RBAC.Role_Gentell_OutsSpecialist) == undefined
                                                                    && this.props.roles.roleList.find(x => x.roleName == RBAC.Role_Gentell_EnteralSpecialist) == undefined} onChange={(e) =>
                                                                        Common.updateInputValueInState(
                                                                            this.state.Facilty,
                                                                            e,
                                                                            this,
                                                                            this.state
                                                                        )
                                                                    }
                                                                className="form-control form-control-sm"
                                                            />
                                                        </div>
                                                    </div>
                                                </div>
                                                

                                            
                                                <div className="row">
                                                    <div className="col-sm-6 col-md-6 col-lg-6 col-xl-4">
                                                        <div className="form-group">
                                                            <label
                                                                className="form-label"
                                                                htmlFor="PartBReceivingPerson"
                                                            >
                                                                Part B Receiving Person
                                                            </label>
                                                            <input
                                                                type="text"
                                                                id="PartBReceivingPerson"
                                                                name="partBrecPerson"
                                                                defaultValue={this.state.Facilty.partBrecPerson}

                                                                onChange={(e) =>
                                                                    Common.updateInputValueInState(
                                                                        this.state.Facilty,
                                                                        e,
                                                                        this,
                                                                        this.state
                                                                    )
                                                                }
                                                                className="form-control form-control-sm"
                                                            />
                                                        </div>
                                                    </div>
                                                    <div className="col-sm-6 col-md-4 col-lg-4 col-xl-4">
                                                        <div className="form-group">
                                                            <label className="form-label" htmlFor="Phone1">
                                                                Receiving Person Phone #
                                                            </label>
                                                            <input
                                                                type="phone"
                                                                id="partBrecPersonPhone"
                                                                name="partBrecPersonPhone"
                                                                value={Common.getFormattedPhoneNum(this.state.Facilty.partBrecPersonPhone)}

                                                                onChange={(e) =>
                                                                    Common.updateInputValueInState(
                                                                        this.state.Facilty,
                                                                        e,
                                                                        this,
                                                                        this.state
                                                                    )
                                                                }
                                                                className="form-control form-control-sm"
                                                            />
                                                        </div>
                                                    </div>


                                                    <div className="col-sm-6 col-md-4 col-lg-4 col-xl-4">
                                                        <div className="form-group">
                                                            <label className="form-label" htmlFor="Phone1">
                                                                Receiving Person Email
                                                            </label>
                                                            <input
                                                                type="phone"
                                                                id="partBrecPersonEmail"
                                                                name="partBrecPersonEmail"
                                                                defaultValue={this.state.Facilty.partBrecPersonEmail}
                                                                onChange={(e) =>
                                                                    Common.updateInputValueInState(
                                                                        this.state.Facilty,
                                                                        e,
                                                                        this,
                                                                        this.state
                                                                    )
                                                                }
                                                                className="form-control form-control-sm"
                                                            />
                                                        </div>
                                                    </div>
                                                </div>

                                                <div className="row">
                                                    <div className="col-sm-6 col-md-6 col-lg-6 col-xl-4">
                                                        <div className="form-group">
                                                            <label
                                                                className="form-label"
                                                                htmlFor="Central Supply Person"
                                                            >
                                                                Central Supply Person
                                                            </label>
                                                            <input
                                                                type="text"
                                                                id="Stree2:"
                                                                name="centralSupplyPerson"
                                                                defaultValue={this.state.Facilty.centralSupplyPerson}

                                                                onChange={(e) =>
                                                                    Common.updateInputValueInState(
                                                                        this.state.Facilty,
                                                                        e,
                                                                        this,
                                                                        this.state
                                                                    )
                                                                }
                                                                className="form-control form-control-sm"
                                                            />
                                                        </div>
                                                    </div>
                                                    <div className="col-sm-6 col-md-4 col-lg-4 col-xl-4">
                                                        <div className="form-group">
                                                            <label className="form-label" htmlFor="Phone1">
                                                                Central Supply Person Phone #
                                                            </label>
                                                            <input
                                                                type="phone"
                                                                id="centerSupplyPersonPhone"
                                                                name="centerSupplyPersonPhone"
                                                                value={Common.getFormattedPhoneNum(this.state.Facilty.centerSupplyPersonPhone)}
                                                                onChange={(e) =>
                                                                    Common.updateInputValueInState(
                                                                        this.state.Facilty,
                                                                        e,
                                                                        this,
                                                                        this.state
                                                                    )
                                                                }
                                                                className="form-control form-control-sm"
                                                            />
                                                        </div>
                                                    </div>
                                                    <div className="col-sm-6 col-md-4 col-lg-4 col-xl-4">
                                                        <div className="form-group">
                                                            <label className="form-label" htmlFor="Phone1">
                                                                Central Supply Person Email
                                                            </label>
                                                            <input
                                                                type="text"
                                                                id="centerSupplyPersonEmail"
                                                                name="centerSupplyPersonEmail"
                                                                defaultValue={this.state.Facilty.centerSupplyPersonEmail}

                                                                onChange={(e) =>
                                                                    Common.updateInputValueInState(
                                                                        this.state.Facilty,
                                                                        e,
                                                                        this,
                                                                        this.state
                                                                    )
                                                                }
                                                                className="form-control form-control-sm"
                                                            />
                                                        </div>
                                                    </div>
                                                </div>

                                                <div className="row">
                                                    <div className="col-4">
                                                        <div className="form-group">
                                                            <label className="form-label" htmlFor="gender">
                                                                Medical Director or Physician signing Facility CMNs

                                                            </label>
                                                            

                                                            <AsyncSelect
                                                                // defaultOptions
                                                                // menuPosition="fixed"
                                                                name='organizationID'
                                                                inputValue={this.state.physiciansInputValue}
                                                                onInputChange={this.setPhysicianInputValue}
                                                                value={this.state.physician}
                                                                onChange={(obj) => {
                                                                    this.setPhysician(obj)
                                                                }}

                                                                loadOptions={this.loadPhysicians}
                                                                isClearable
                                                            />
                                                        </div>
                                                    </div>
                                                    <div className="col-4">
                                                        <div className="form-group mt-7">
                                                            <label className="form-label" htmlFor="email">Email</label>
                                                            <input
                                                                type="text"
                                                                name="email"
                                                                id="email"
                                                                className="form-control form-control-sm"
                                                                value={this.state.Facilty.email}
                                                                onChange={(e) => {
                                                                    Common.updateInputValueInState(this.state.Facilty, e, this, this.state);
                                                                    if (e.target.value && !Common.isValidEmail(e.target.value)) {
                                                                        this.setState({ emailError: true })
                                                                    } else {
                                                                        this.setState({ emailError: false })
                                                                    }
                                                                }
                                                                }
                                                            />
                                                        </div>
                                                    </div>
                                                    <div className="col-4">
                                                        <div className="form-group mt-15">
                                                            <label className="checkbox">
                                                                <input
                                                                    type="checkbox"
                                                                    name="singingForAllCmns"
                                                                    checked={this.state.Facilty.singingForAllCmns}

                                                                    onChange={(e) =>
                                                                        Common.updateInputValueInState(
                                                                            this.state.Facilty,
                                                                            e,
                                                                            this,
                                                                            this.state
                                                                        )
                                                                    }
                                                                    className="m-1"
                                                                />
                                                                <span className="mr-3" />
                                                                Signing For All CMNs
                                                            </label>
                                                        </div>
                                                    </div>
                                                </div>
                                              
                                            </div>
                                        </div>
                                        {/* </div> */}
                                        <div className="row">
                                            <div className="col-12">
                                                <div className="form-group">
                                                    <label className="form-label" htmlFor="Memo">
                                                        Memo
                                                    </label>
                                                    <textarea
                                                        className="form-control"
                                                        name="memo"
                                                        defaultValue={this.state.Facilty.memo}
                                                        onChange={(e) =>
                                                            Common.updateInputValueInState(
                                                                this.state.Facilty,
                                                                e,
                                                                this,
                                                                this.state
                                                            )
                                                        }
                                                        id="Memo"
                                                        rows="3"
                                                    ></textarea>
                                                </div>
                                            </div>
                                        </div>
                                    </fieldset>
                                </>
                            </Form>
                            {
                                <PopupModal
                                    size="lg"
                                    title="Add EMR"
                                    module={ModulesName.Module_Setup}
                                    action={UserActions.Create}
                                    buttonPress={() => addEMR.onSubmit()}
                                    ref={(ref) => {
                                        emrModal = ref;
                                    }}
                                >
                                    {" "}
                                    <AddEMRCredentail
                                        ref={(ref) => {
                                            addEMR = ref;
                                        }}
                                        onSaveAPI={() => this.onEMRFormSubmit()}
                                        emr={this.state.emr}
                                    />{" "}
                                </PopupModal>

                            }
                            <PopupModal
                                size="lg"
                                title="Facility Group"
                                module={ModulesName.Module_Setup}
                                action={UserActions.Create}
                                buttonPress={() => facilityGroupModal.onSubmit()}
                                ref={(ref) => {
                                    facilityGroupModal = ref;
                                }}
                            >
                                {" "}
                                <AddFacilityGroup
                                    ref={(ref) => {
                                        facilityGroupModal = ref;
                                    }}
                                    onSaveAPI={() => this.onEMRFormSubmit()}
                                    isHeadquarters={this.state.isHeadquarters}
                                    selectOrgOptions={this.state.selectOrgOptions}
                                />{" "}
                            </PopupModal>
                        </div> :
                        <div className="d-flex justify-content-center">
                            <Loader
                                type="Puff"
                                color="#00BFFF"
                                height={50}
                                width={50}
                            />
                        </div>
                    }
                </Animated>
                }</>


        );
    }
}
const mapStateToProps = (state) => {
    const roles = state.auth.user.roles;
    return { roles }
};
export default
    connect(mapStateToProps,
        {}
        , null, { forwardRef: true })(AddFacility);


